var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 34,
    viewBox: "0 0 42 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1937 34C38.1518 34 41.7801 30.3571 41.7801 26.3831C41.7801 21.1948 38.4817 18.3247 34.5236 18.3247C28.4764 18.3247 31.6649 8.38961 42 3.53247L39.6911 0C32.9843 2.42857 24.1885 10.7078 24.1885 21.8571C24.1885 26.7143 26.0576 34 34.1937 34ZM10.0052 34C13.9633 34 17.5916 30.3571 17.5916 26.3831C17.5916 21.1948 14.2932 18.3247 10.3351 18.3247C4.28796 18.3247 7.47644 8.38961 17.8115 3.53247L15.5026 0C8.79581 2.42857 0 10.7078 0 21.8571C0 26.7143 1.86911 34 10.0052 34Z",
    fill: "#FF7535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.feebe9a8909dec04bfab2f1da2726ae4.svg";
export { ForwardRef as ReactComponent };